// @flow
import React from 'react';

import styles from './textarea.css';


type TextareaPropTypes = {
  size?: string,
  className?: string,
  isSquare?: boolean,
  isStacked?: boolean,
  hasError?: boolean,
  elevation?: number,
  clearMargins?: boolean,
};

const Textarea = ({
  size = 'medium',
  className = '',
  isSquare = false,
  isStacked = false,
  hasError = false,
  elevation = 1,
  clearMargins = false,
  ...props
}: TextareaPropTypes) => (
  <textarea
    {...props}
    className={
      `
        ${styles.textarea}
        ${styles[size]}
        ${className}
        ${isSquare ? styles.squareBorderRadius : ''}
        ${styles[`elevation${elevation}`]}
        ${clearMargins ? styles.noMargins : ''}
        ${isStacked ? styles.stacked : ''}
        ${hasError ? styles.error : ''}
      `
    }
  />
);

export default Textarea;



// WEBPACK FOOTER //
// ./src/scripts/components/Textarea/index.jsx